// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationHeader_location-popup-image__EyGY3 {
  height: 180px;
  width: 250px;
  padding: 6px;
}
.LocationHeader_location-popup-image__EyGY3 > div {
  border-radius: 5px;
  background-position: center;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.LocationHeader_location-popup-image-group__jfsHs {
  padding: 4px;
  display: grid;
  width: 250px;
  height: 180px;
}
.LocationHeader_location-popup-image-group__jfsHs > div {
  margin: 2px;
  border-radius: 5px;
  background-position: center;
  background-size: cover;
}

.LocationHeader_location-popup-image-group__jfsHs.LocationHeader_two__lUXhg {
  grid-template-rows: 50% 50%;
}

.LocationHeader_location-popup-image-group__jfsHs.LocationHeader_three__ZfdAX {
  grid-template-columns: 50% 50%;
  grid-template-rows: 60% 40%;
}
.LocationHeader_location-popup-image-group__jfsHs.LocationHeader_three__ZfdAX > div:nth-child(1) {
  grid-column-start: 1;
  grid-column-end: 3;
}

.LocationHeader_location-popup-image-group__jfsHs.LocationHeader_many__1zdVY {
  grid-template-rows: 50% 50%;
  grid-template-columns: 50% 50%;
}
.LocationHeader_location-popup-image-group__jfsHs.LocationHeader_many__1zdVY .LocationHeader_additional-images__nSCb\\+ {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5333333333);
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2em;
  font-weight: 700;
}

.LocationHeader_location-popup-text__31Lmc {
  padding: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.LocationHeader_location-popup-text__31Lmc .LocationHeader_heading__6XCy7 {
  font-weight: 700;
}
.LocationHeader_location-popup-text__31Lmc .LocationHeader_description__EyLux {
  white-space: pre-line;
}
.LocationHeader_location-popup-text__31Lmc .LocationHeader_description__EyLux:hover .LocationHeader_see-more__JpPld {
  color: rgb(6, 91, 189);
}
.LocationHeader_location-popup-text__31Lmc .LocationHeader_see-more__JpPld {
  color: rgb(100, 100, 100);
  cursor: pointer;
}

/* Default styles for location-owner */
.LocationHeader_location-owner__\\+\\+bmX {
  color: gray;
  font-style: italic;
}

/* Styles for owner "Your Location" */
.LocationHeader_location-owner-self__TdyVv {
  color: green; /* Change to your desired color */
}

/* Styles for other owners */
.LocationHeader_location-owner-other__6RkPe {
  color: orange; /* Change to your desired color */
}`, "",{"version":3,"sources":["webpack://./src/Components/LocationHeader/LocationHeader.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,YAAA;AACF;AACE;EACI,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AACN;;AAGA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AAAF;AAEE;EACI,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;AAAN;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,8BAAA;EACA,2BAAA;AADF;AAGE;EACI,oBAAA;EACA,kBAAA;AADN;;AAKA;EACE,2BAAA;EACA,8BAAA;AAFF;AAIE;EACI,YAAA;EACA,WAAA;EACA,6CAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAFN;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHF;AAKE;EACI,gBAAA;AAHN;AAME;EACI,qBAAA;AAJN;AAMM;EACI,sBAAA;AAJV;AAQE;EACI,yBAAA;EACA,eAAA;AANN;;AAUA,sCAAA;AACA;EACE,WAAA;EACA,kBAAA;AAPF;;AAUA,qCAAA;AACA;EACE,YAAA,EAAA,iCAAA;AAPF;;AAUA,4BAAA;AACA;EACE,aAAA,EAAA,iCAAA;AAPF","sourcesContent":[".location-popup-image {\n  height: 180px;\n  width: 250px;\n  padding: 6px;\n\n  > div {\n      border-radius: 5px;\n      background-position: center;\n      background-size: cover;\n      height: 100%;\n      width: 100%;\n  }\n}\n\n.location-popup-image-group {\n  padding: 4px;\n  display: grid;\n  width: 250px;\n  height: 180px;\n\n  > div {\n      margin: 2px;\n      border-radius: 5px;\n      background-position: center;\n      background-size: cover;\n  }\n}\n\n.location-popup-image-group.two {\n  grid-template-rows: 50% 50%;\n}\n\n.location-popup-image-group.three {\n  grid-template-columns: 50% 50%;\n  grid-template-rows: 60% 40%;\n\n  > div:nth-child(1) {\n      grid-column-start: 1;\n      grid-column-end: 3;\n  }\n}\n\n.location-popup-image-group.many {\n  grid-template-rows: 50% 50%;\n  grid-template-columns: 50% 50%;\n\n  .additional-images {\n      height: 100%;\n      width: 100%;\n      background-color: #0008;\n      border-radius: inherit;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      font-size: 2em;\n      font-weight: 700;\n  }\n}\n\n.location-popup-text {\n  padding: 10px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .heading {\n      font-weight: 700;\n  }\n\n  .description {\n      white-space: pre-line;\n\n      &:hover .see-more {\n          color: rgb(6, 91, 189);\n      }\n  }\n\n  .see-more {\n      color: rgb(100, 100, 100);\n      cursor: pointer;\n  }\n}\n\n/* Default styles for location-owner */\n.location-owner {\n  color: gray;\n  font-style: italic;\n}\n\n/* Styles for owner \"Your Location\" */\n.location-owner-self {\n  color: green; /* Change to your desired color */\n}\n\n/* Styles for other owners */\n.location-owner-other {\n  color: orange; /* Change to your desired color */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"location-popup-image": `LocationHeader_location-popup-image__EyGY3`,
	"location-popup-image-group": `LocationHeader_location-popup-image-group__jfsHs`,
	"two": `LocationHeader_two__lUXhg`,
	"three": `LocationHeader_three__ZfdAX`,
	"many": `LocationHeader_many__1zdVY`,
	"additional-images": `LocationHeader_additional-images__nSCb+`,
	"location-popup-text": `LocationHeader_location-popup-text__31Lmc`,
	"heading": `LocationHeader_heading__6XCy7`,
	"description": `LocationHeader_description__EyLux`,
	"see-more": `LocationHeader_see-more__JpPld`,
	"location-owner": `LocationHeader_location-owner__++bmX`,
	"location-owner-self": `LocationHeader_location-owner-self__TdyVv`,
	"location-owner-other": `LocationHeader_location-owner-other__6RkPe`
};
export default ___CSS_LOADER_EXPORT___;
